import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaToxicologicaInterface } from "../../../../../interfaces/FechaToxicologicaInterface";
import { ExamenTXInterface } from "../../../../../interfaces/ExamenTXInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ReporteExamenTXListaPrint = () => {
  const tituloFormulario = "REPORTE EXAMEN TRABAJADOR";
  const { control, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);

  const [] = useState({
    date: "",
    name: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    console.log("Datos guardados:", {
      ...formData,
      images,
    });

    navigate(`/domiciliaria/${evaluadosList_id}`);
  };

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaTX = useGetData<FechaToxicologicaInterface[]>({
    url: `/fecha-toxi/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const mutateFechaTX = useMutationData({
    url: `/fecha-toxi/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-toxi"],
  });

  const queryExamenTX = useGetData<ExamenTXInterface>({
    url: `/examentx/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "examentx"],
  });

  const mutateExamenTX = useMutationData({
    url: `/examentx/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "examentx"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedMotivo, setSelectedMotivo] = useState<string | null>(null);
  const [selectedSalud, setSelectedSalud] = useState<string | null>(null);
  const [selectedMedicamentos, setSelectedMedicamentos] = useState<
    string | null
  >(null);
  const [selectedRango, setSelectedRango] = useState<string | null>(null);
  const [selectedMarihuana, setSelectedMarihuana] = useState<string | null>(
    null
  );
  const [selectedCocaina, setSelectedCocaina] = useState<string | null>(null);
  const [selectedOpiaceos, setSelectedOpiaceos] = useState<string | null>(null);
  const [selectedAnfetamina, setSelectedAnfetamina] = useState<string | null>(
    null
  );
  const [selectedMetanfetamina, setSelectedMetanfetamina] = useState<
    string | null
  >(null);
  const [selectedBenzodiacepina, setSelectedBenzodiacepina] = useState<
    string | null
  >(null);

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      console.log("Fecha de nacimiento:", fechaNac);
      console.log("Edad calculada:", nuevaEdad);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryFechaTX.data && queryFechaTX.data.length > 0) {
      const fechatx = queryFechaTX.data[0];
      reset({
        fecha_autorizaciontx: fechatx.fecha_autorizaciontx || "",
      });
    }
  }, [queryFechaTX.data, reset]);

  useEffect(() => {
    if (queryExamenTX.data) {
      reset({
        folio_tx: queryExamenTX.data.folio_tx || "",
        nombrecentro_trabajotx: queryExamenTX.data.nombrecentro_trabajotx || "",
        domicilio_trabajotx: queryExamenTX.data.domicilio_trabajotx || "",
        motivo_trabajotx: queryExamenTX.data.motivo_trabajotx || "",
        identifica_tx: queryExamenTX.data.identifica_tx || "",
        estado_saludtx: queryExamenTX.data.estado_saludtx || "",
        tomar_medicamentostx: queryExamenTX.data.tomar_medicamentostx || "",
        nombre_medicamentotx: queryExamenTX.data.nombre_medicamentotx || "",
        porque_medicamentotx: queryExamenTX.data.porque_medicamentotx || "",
        panel_multidrogastx: queryExamenTX.data.panel_multidrogastx || "",
        vaso_multidrogastx: queryExamenTX.data.vaso_multidrogastx || "",
        temperatura_tx: queryExamenTX.data.temperatura_tx || "",
        rango_normaltx: queryExamenTX.data.rango_normaltx || "",
        marihuanatx: queryExamenTX.data.marihuanatx || "",
        cocainatx: queryExamenTX.data.cocainatx || "",
        opiaceostx: queryExamenTX.data.opiaceostx || "",
        anfetaminatx: queryExamenTX.data.anfetaminatx || "",
        metanfetaminatx: queryExamenTX.data.metanfetaminatx || "",
        benzodiacepinatx: queryExamenTX.data.benzodiacepinatx || "",
        lotetx: queryExamenTX.data.lotetx || "",
        fecha_caducidadtx: queryExamenTX.data.fecha_caducidadtx || "",
        nombre_recolectortx: queryExamenTX.data.nombre_recolectortx || "",
        evaluado_uuid: queryExamenTX.data.evaluado_uuid || "",
      });
      setSelectedMotivo(queryExamenTX.data.motivo_trabajotx || null);
      setSelectedSalud(queryExamenTX.data.estado_saludtx || null);
      setSelectedMedicamentos(
        queryExamenTX.data.tomar_medicamentostx ? "true" : "false"
      );
      setSelectedRango(queryExamenTX.data.rango_normaltx ? "true" : "false");
      setSelectedMarihuana(queryExamenTX.data.marihuanatx || null);
      setSelectedCocaina(queryExamenTX.data.cocainatx || null);
      setSelectedOpiaceos(queryExamenTX.data.opiaceostx || null);
      setSelectedAnfetamina(queryExamenTX.data.anfetaminatx || null);
      setSelectedMetanfetamina(queryExamenTX.data.metanfetaminatx || null);
      setSelectedBenzodiacepina(queryExamenTX.data.benzodiacepinatx || null);
    }
  }, [queryExamenTX.data, reset]);

  console.log("Valores: ", selectedMotivo);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-4 p-4">
        {/* Table section */}
        <div>
          <table className="w-full text-sm border-collapse border border-slate-700">
            <tbody>
              <tr>
                {/* Columna izquierda: título */}
                <td className="w-1/2 border-2 border-slate-700 text-center font-semibold bg-customCyan">
                  TRABAJADOR / REPORTE EXÁMEN
                  <br />
                  (Prevención de sustancias de abuso)
                </td>
                {/* Columna derecha: contenido */}
                <td className="w-1/2 border-2 border-slate-700 text-left">
                  <div className="flex items-center space-x-4 p-2">
                    <Label className="flex-shrink-0">
                      No. DE CONTROL O FOLIO:
                    </Label>
                    <Controller
                      name="folio_tx"
                      control={control}
                      defaultValue={queryExamenTX.data?.folio_tx || ""}
                      render={({ field }) => (
                        <TextInput
                          id="folio_tx"
                          type="text"
                          className="w-40px"
                          {...field}
                          value={field.value}
                          disabled={true}
                        />
                      )}
                    />
                  </div>
                  <div className="flex items-center space-x-4 p-2">
                    <Label className="flex-shrink-0">FECHA:</Label>
                    <Controller
                      name="fecha_examentx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="fecha_examentx"
                          type="date"
                          {...field}
                          value={
                            field.value ||
                            (queryFechaTX.data && queryFechaTX.data.length > 0
                              ? queryFechaTX.data[0]?.fecha_examentx || ""
                              : "")
                          }
                          disabled={true}
                        />
                      )}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h4 className="text-left">MODULO I.-EMPRESA</h4>
          {/* Table section */}
          <div>
            <table className="w-full text-sm border-collapse border border-slate-700">
              <tbody>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    NOMBRE DEL CENTRO DE TRABAJO:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Controller
                      name="nombrecentro_trabajotx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="nombrecentro_trabajotx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.nombrecentro_trabajotx}
                          disabled={true}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    DOMICILIO:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Controller
                      name="domicilio_trabajotx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="domicilio_trabajotx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.domicilio_trabajotx}
                          disabled={true}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna única que abarca ambas columnas */}
                  <td
                    colSpan={2}
                    className="border-2 border-slate-700 text-left font-semibold p-2"
                  >
                    CON BASE A LA NOM-030-STPS-2009 Y EL REGLAMENTO FEDERAL DE
                    SEGURIDAD Y SALUD EN EL TRABAJO, SE REALIZA EL EXÁMEN PARA
                    LA PREVENCIÓN DE TOXICOMANIAS EN EL CENTRO DE TRABAJO POR:
                    <br />
                    {/* Radio buttons centrados y con más espacio entre ellos */}
                    <div className="flex justify-center space-x-8 mt-4">
                      <label>
                        <Controller
                          name="motivo_trabajotx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                type="radio"
                                {...field}
                                name="motivo_trabajotx"
                                value="Nuevo Ingreso"
                                checked={selectedMotivo === "Nuevo Ingreso"}
                                onChange={() => {
                                  field.onChange("Nuevo Ingreso");
                                  setSelectedMotivo("Nuevo Ingreso");
                                }}
                                disabled={true}
                                className="print-radio"
                              />
                              {/* Marcador visual adicional */}
                              {selectedMotivo === "Nuevo Ingreso" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                              NUEVO INGRESO
                            </div>
                          )}
                        />
                      </label>
                      <label className="flex items-center">
                        <Controller
                          name="motivo_trabajotx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                id="motivo_trabajotx"
                                type="radio"
                                {...field}
                                name="motivo_trabajotx"
                                value="Programa Preventivo"
                                checked={
                                  selectedMotivo === "Programa Preventivo"
                                }
                                onChange={() => {
                                  field.onChange("Programa Preventivo");
                                  setSelectedMotivo("Programa Preventivo");
                                }}
                                disabled={true}
                                className="print-radio"
                              />
                              {selectedMotivo === "Programa Preventivo" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                              PROGRAMA PREVENTIVO
                            </div>
                          )}
                        />
                      </label>

                      <label className="flex items-center">
                        <Controller
                          name="motivo_trabajotx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                id="motivo_trabajotx"
                                type="radio"
                                {...field}
                                name="motivo_trabajotx"
                                value="Otro"
                                checked={selectedMotivo === "Otro"}
                                onChange={() => {
                                  field.onChange("Otro");
                                  setSelectedMotivo("Otro");
                                }}
                                disabled={true}
                                className="print-radio"
                              />
                              {selectedMotivo === "Otro" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                              OTRO
                            </div>
                          )}
                        />
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-[25px]"></div>
          <h4 className="text-left">MODULO II.- TRABAJADOR</h4>
          {/* Table section */}
          <div>
            <table className="w-full text-sm border-collapse border border-slate-700">
              <tbody>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    NOMBRE DEL EVALUADO:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Label
                      value={`${queryEvaluado.data?.nombre || ""} ${
                        queryEvaluado.data?.apellido_paterno || ""
                      } ${queryEvaluado.data?.apellido_materno || ""}`}
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    EMPRESA EN LA QUE LABORA:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Label
                      value={queryEvaluado.data?.empresa_id?.nombre || ""}
                    ></Label>
                  </td>
                </tr>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    FECHA DE NACIMIENTO:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Label
                      value={
                        queryEvaluado.data?.fecha_nacimiento
                          ? (() => {
                              const [year, month, day] =
                                queryEvaluado.data.fecha_nacimiento.split("-");
                              return `${day}/${month}/${year}`;
                            })()
                          : ""
                      }
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    SE IDENTIFICA CON:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Controller
                      name="identifica_tx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="identifica_tx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.identifica_tx}
                          disabled={true}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna única que abarca ambas columnas */}
                  <td
                    colSpan={2}
                    className="border-2 border-slate-700 text-left font-semibold p-2"
                  >
                    MANIFIESTO QUE MI ESTADO DE SALUD EN GENERAL ES:
                    <br />
                    {/* Radio buttons centrados y con más espacio entre ellos */}
                    <div className="flex justify-center space-x-8 mt-4">
                      <label className="flex items-center">
                        <Controller
                          name="estado_saludtx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                type="radio"
                                {...field}
                                name="estado_saludtx"
                                value="Bueno"
                                disabled={true}
                                checked={selectedSalud === "Bueno"}
                                onChange={() => {
                                  field.onChange("Bueno");
                                  setSelectedSalud("Bueno");
                                }}
                                className="print-radio"
                              />
                              {selectedSalud === "Bueno" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        BUENO
                      </label>

                      <label className="flex items-center">
                        <Controller
                          name="estado_saludtx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                type="radio"
                                {...field}
                                name="estado_saludtx"
                                value="Regular"
                                disabled={true}
                                checked={selectedSalud === "Regular"}
                                onChange={() => {
                                  field.onChange("Regular");
                                  setSelectedSalud("Regular");
                                }}
                                className="print-radio"
                              />
                              {selectedSalud === "Regular" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        REGULAR
                      </label>

                      <label className="flex items-center">
                        <Controller
                          name="estado_saludtx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                type="radio"
                                {...field}
                                name="estado_saludtx"
                                value="Malo"
                                disabled={true}
                                checked={selectedSalud === "Malo"}
                                onChange={() => {
                                  field.onChange("Malo");
                                  setSelectedSalud("Malo");
                                }}
                                className="print-radio"
                              />
                              {selectedSalud === "Malo" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        MALO
                      </label>

                      <label className="flex items-center">
                        <Controller
                          name="estado_saludtx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                type="radio"
                                {...field}
                                name="estado_saludtx"
                                value="Con Problemas Crónicos"
                                disabled={true}
                                checked={
                                  selectedSalud === "Con Problemas Crónicos"
                                }
                                onChange={() => {
                                  field.onChange("Con Problemas Crónicos");
                                  setSelectedSalud("Con Problemas Crónicos");
                                }}
                                className="print-radio"
                              />
                              {selectedSalud === "Con Problemas Crónicos" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        CON PROBLEMAS CRÓNICOS
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  {/* Columna única que abarca ambas columnas */}
                  <td
                    colSpan={2}
                    className="border-2 border-slate-700 text-left font-semibold p-2"
                  >
                    EN LOS ÚLTIMOS 30 DÍAS HE TOMADO MEDICAMENTOS:
                    <br />
                    {/* Radio buttons centrados y con más espacio entre ellos */}
                    <div className="flex justify-center space-x-8 mt-4">
                      <label className="flex items-center">
                        <Controller
                          name="tomar_medicamentostx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                id="tomar_medicamentostx"
                                type="radio"
                                {...field}
                                name="tomar_medicamentostx"
                                value="true"
                                disabled={true}
                                checked={selectedMedicamentos === "true"}
                                onChange={() => {
                                  field.onChange("true");
                                  setSelectedMedicamentos("true");
                                }}
                                className="print-radio"
                              />
                              {selectedMedicamentos === "true" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        SI
                      </label>

                      <label className="flex items-center">
                        <Controller
                          name="tomar_medicamentostx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                id="tomar_medicamentostx"
                                type="radio"
                                {...field}
                                name="tomar_medicamentostx"
                                value="false"
                                disabled={true}
                                checked={selectedMedicamentos === "false"}
                                onChange={() => {
                                  field.onChange("false");
                                  setSelectedMedicamentos("false");
                                }}
                                className="print-radio"
                              />
                              {selectedMedicamentos === "false" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        NO
                      </label>
                    </div>
                  </td>
                </tr>
                <br />
                <tr>
                  {/* Columna única que abarca ambas columnas */}
                  <td
                    colSpan={2}
                    className="border-2 border-slate-700 text-left font-semibold p-2"
                  >
                    EN CASO AFIRMATIVO, DESCRIBA EL NOMBRE DEL MEDICAMENTO(S) Y
                    PORQUE LOS TOMÓ:
                    <br />
                    <div>
                      <Controller
                        name="nombre_medicamentotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <TextInput
                            id="nombre_medicamentotx"
                            type="text"
                            {...field}
                            value={queryExamenTX.data?.nombre_medicamentotx}
                            disabled={true}
                            placeholder="Nombre de los medicamentos..."
                          />
                        )}
                      />
                      <br />
                      <Controller
                        name="porque_medicamentotx"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <textarea
                            id="porque_medicamentotx"
                            {...field}
                            value={queryExamenTX.data?.porque_medicamentotx}
                            disabled={true}
                            className="w-full h-32 p-3 border-2 border-slate-700 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-customCyan"
                            placeholder="Escriba aquí el porque..."
                          />
                        )}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-[25px]"></div>
          <h4 className="text-left">
            MODULO III.- AUTORIZACIÓN DEL TRABAJADOR
          </h4>
          {/* Table section */}
          <div>
            <table className="w-full text-sm border-collapse border border-slate-700">
              <tbody>
                <tr>
                  {/* Columna única que abarca ambas columnas */}
                  <td
                    colSpan={2}
                    className="border-2 border-slate-700 text-left font-semibold p-2"
                  >
                    <div className="text-justify">
                      EL QUE SUSCRIBE{" "}
                      <Label
                        value={`${queryEvaluado.data?.nombre || ""} ${
                          queryEvaluado.data?.apellido_paterno || ""
                        } ${queryEvaluado.data?.apellido_materno || ""}`}
                        className="inline-block w-auto uppercase font-bold"
                      />{" "}
                      MANIFIESTO QUE LEÍ EL MODULO I DESCRITO EN ESTE FORMATO Y
                      AUTORIZO LA REALIZACIÓN DEL ANÁLISIS CLÍNICO, PARA LO CUAL
                      DONO UNA MUESTRA DE ORINA, VERIFICANDO PREVIAMENTE QUE EL
                      REACTIVO Y RECIPIENTE RECOLECTOR SON NUEVOS, ESTÁN
                      SELLADOS Y SU FECHA DE CADUCIDAD ES VIGENTE. ASIMISMO, DOY
                      MI CONSENTIMIENTO PARA ENVIAR ESTA MUESTRA DE ORINA A UN
                      LABORATORIO EN CASO DE OBTENER UN RESULTADO “NO NEGATIVO”
                      Y SEA REQUERIDA UNA PRUEBA CONFIRMATORIA. ASIMISMO;
                      AUTORIZO A LA EMPRESA SKA TRACKING AND SECURITY S.A. DE
                      C.V. PARA QUE PROPORCIONE TODA LA INFORMACIÓN, DOCUMENTOS
                      Y TODA LA INFORMACIÓN QUE DERIVEN DE LAS EVALUACIONES DE
                      PRUEBAS DE CONFIANZA QUE SE ME REALICEN.
                      <div className="mt-[50px]"></div>
                      <h5 className="text-center">
                        _____________________
                        <br />
                        Firma del Evaluado
                      </h5>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-[25px]"></div>
          <h4 className="text-left">
            MODULO IV.- METODO DE DETECCIÓN (USO EXCLUSIVO DE LA EMPRESA)
          </h4>
          {/* Table section */}
          <div>
            <table className="w-full text-sm border-collapse border border-slate-700 table-fixed">
              <tbody>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    PANEL MULTIDROGAS DE:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Controller
                      name="panel_multidrogastx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="panel_multidrogastx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.panel_multidrogastx}
                          disabled={true}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    VASO MULTIDROGAS DE:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <Controller
                      name="vaso_multidrogastx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="vaso_multidrogastx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.vaso_multidrogastx}
                          disabled={true}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/3 border-2 border-slate-700 text-left font-semibold">
                    TEMPERATURA:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/3 border-2 border-slate-700 text-left font-semibold">
                    <Controller
                      name="temperatura_tx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="temperatura_tx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.temperatura_tx}
                          disabled={true}
                        />
                      )}
                    />
                  </td>
                </tr>
                <tr>
                  {/* Columna izquierda: título */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    RANGO NORMAL:
                  </td>
                  {/* Columna derecha: contenido */}
                  <td className="w-1/2 border-2 border-slate-700 text-left font-semibold">
                    <div className="flex justify-center space-x-8">
                      <label className="flex items-center">
                        <Controller
                          name="rango_normaltx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                id="rango_normaltx_si"
                                type="radio"
                                {...field}
                                name="rango_normaltx"
                                value="true"
                                disabled={true}
                                checked={selectedRango === "true"}
                                onChange={() => {
                                  field.onChange("true");
                                  setSelectedRango("true");
                                }}
                                className="print-radio"
                              />
                              {selectedRango === "true" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        SI
                      </label>

                      <label className="flex items-center">
                        <Controller
                          name="rango_normaltx"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div className="relative flex items-center">
                              <input
                                id="rango_normaltx_no"
                                type="radio"
                                {...field}
                                name="rango_normaltx"
                                value="false"
                                disabled={true}
                                checked={selectedRango === "false"}
                                onChange={() => {
                                  field.onChange("false");
                                  setSelectedRango("false");
                                }}
                                className="print-radio"
                              />
                              {selectedRango === "false" && (
                                <div className="absolute left-0 w-3 h-3 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          )}
                        />
                        NO
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-[50px]"></div>
          <div>
            <table className="w-full text-sm border-collapse border border-slate-700">
              <thead>
                <tr>
                  <th className="border-2 border-slate-700 text-left font-semibold p-2 w-2/5">
                    RESULTADO
                  </th>
                  <th className="border-2 border-slate-700 text-left font-semibold p-2 w-1/4">
                    PRUEBA EMPLEADA
                  </th>
                  <th className="border-2 border-slate-700 text-left font-semibold p-2 w-1/3">
                    DATOS DEL RECOLECTOR
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border-2 border-slate-700 p-0">
                    <table className="w-full">
                      <tbody>
                        <tr>
                          <td className="border-2 border-slate-700 text-left w-8">
                            No.
                          </td>
                          <td className="border-2 border-slate-700 text-left">
                            DROGA
                          </td>
                          <td className="border-2 border-slate-700 text-center w-12">
                            ( + )
                          </td>
                          <td className="border-2 border-slate-700 text-center w-12">
                            ( - )
                          </td>
                        </tr>

                        {/* Fila Marihuana */}
                        <tr>
                          <td className="border-2 border-slate-700 text-left">
                            1
                          </td>
                          <td className="border-2 border-slate-700 text-left">
                            MARIHUANA (THC)
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="marihuanatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="marihuanatx_positivo"
                                      type="radio"
                                      {...field}
                                      name="marihuanatx"
                                      value="Positivo"
                                      disabled={true}
                                      checked={selectedMarihuana === "Positivo"}
                                      onChange={() => {
                                        field.onChange("Positivo");
                                        setSelectedMarihuana("Positivo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedMarihuana === "Positivo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="marihuanatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="marihuanatx_negativo"
                                      type="radio"
                                      {...field}
                                      name="marihuanatx"
                                      value="Negativo"
                                      disabled={true}
                                      checked={selectedMarihuana === "Negativo"}
                                      onChange={() => {
                                        field.onChange("Negativo");
                                        setSelectedMarihuana("Negativo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedMarihuana === "Negativo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                        </tr>

                        {/* Fila Cocaína */}
                        <tr>
                          <td className="border-2 border-slate-700 text-left">
                            2
                          </td>
                          <td className="border-2 border-slate-700 text-left">
                            COCAINA (COC)
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="cocainatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="cocainatx_positivo"
                                      type="radio"
                                      {...field}
                                      name="cocainatx"
                                      value="Positivo"
                                      disabled={true}
                                      checked={selectedCocaina === "Positivo"}
                                      onChange={() => {
                                        field.onChange("Positivo");
                                        setSelectedCocaina("Positivo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedCocaina === "Positivo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="cocainatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="cocainatx_negativo"
                                      type="radio"
                                      {...field}
                                      name="cocainatx"
                                      value="Negativo"
                                      disabled={true}
                                      checked={selectedCocaina === "Negativo"}
                                      onChange={() => {
                                        field.onChange("Negativo");
                                        setSelectedCocaina("Negativo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedCocaina === "Negativo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                        </tr>

                        {/* Fila Opiáceos */}
                        <tr>
                          <td className="border-2 border-slate-700 text-left">
                            3
                          </td>
                          <td className="border-2 border-slate-700 text-left">
                            OPIACEOS (OPI)
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="opiaceostx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="opiaceostx_positivo"
                                      type="radio"
                                      {...field}
                                      name="opiaceostx"
                                      value="Positivo"
                                      disabled={true}
                                      checked={selectedOpiaceos === "Positivo"}
                                      onChange={() => {
                                        field.onChange("Positivo");
                                        setSelectedOpiaceos("Positivo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedOpiaceos === "Positivo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="opiaceostx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="opiaceostx_negativo"
                                      type="radio"
                                      {...field}
                                      name="opiaceostx"
                                      value="Negativo"
                                      disabled={true}
                                      checked={selectedOpiaceos === "Negativo"}
                                      onChange={() => {
                                        field.onChange("Negativo");
                                        setSelectedOpiaceos("Negativo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedOpiaceos === "Negativo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                        </tr>

                        {/* Fila Anfetamina */}
                        <tr>
                          <td className="border-2 border-slate-700 text-left">
                            4
                          </td>
                          <td className="border-2 border-slate-700 text-left">
                            ANFETAMINA (AMP)
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="anfetaminatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="anfetaminatx_positivo"
                                      type="radio"
                                      {...field}
                                      name="anfetaminatx"
                                      value="Positivo"
                                      disabled={true}
                                      checked={
                                        selectedAnfetamina === "Positivo"
                                      }
                                      onChange={() => {
                                        field.onChange("Positivo");
                                        setSelectedAnfetamina("Positivo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedAnfetamina === "Positivo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="anfetaminatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="anfetaminatx_negativo"
                                      type="radio"
                                      {...field}
                                      name="anfetaminatx"
                                      value="Negativo"
                                      disabled={true}
                                      checked={
                                        selectedAnfetamina === "Negativo"
                                      }
                                      onChange={() => {
                                        field.onChange("Negativo");
                                        setSelectedAnfetamina("Negativo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedAnfetamina === "Negativo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                        </tr>

                        {/* Fila Metanfetamina */}
                        <tr>
                          <td className="border-2 border-slate-700 text-left">
                            5
                          </td>
                          <td className="border-2 border-slate-700 text-left">
                            METANFETAMINA (mAMP)
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="metanfetaminatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="metanfetaminatx_positivo"
                                      type="radio"
                                      {...field}
                                      name="metanfetaminatx"
                                      value="Positivo"
                                      disabled={true}
                                      checked={
                                        selectedMetanfetamina === "Positivo"
                                      }
                                      onChange={() => {
                                        field.onChange("Positivo");
                                        setSelectedMetanfetamina("Positivo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedMetanfetamina === "Positivo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="metanfetaminatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="metanfetaminatx_negativo"
                                      type="radio"
                                      {...field}
                                      name="metanfetaminatx"
                                      value="Negativo"
                                      disabled={true}
                                      checked={
                                        selectedMetanfetamina === "Negativo"
                                      }
                                      onChange={() => {
                                        field.onChange("Negativo");
                                        setSelectedMetanfetamina("Negativo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedMetanfetamina === "Negativo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                        </tr>

                        {/* Fila Benzodiacepina */}
                        <tr>
                          <td className="border-2 border-slate-700 text-left">
                            6
                          </td>
                          <td className="border-2 border-slate-700 text-left">
                            BENZODIACEPINA (BZO)
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="benzodiacepinatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="benzodiacepinatx_positivo"
                                      type="radio"
                                      {...field}
                                      name="benzodiacepinatx"
                                      value="Positivo"
                                      disabled={true}
                                      checked={
                                        selectedBenzodiacepina === "Positivo"
                                      }
                                      onChange={() => {
                                        field.onChange("Positivo");
                                        setSelectedBenzodiacepina("Positivo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedBenzodiacepina === "Positivo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                          <td className="border-2 border-slate-700 text-center">
                            <div className="flex justify-center">
                              <Controller
                                name="benzodiacepinatx"
                                control={control}
                                render={({ field }) => (
                                  <div className="relative">
                                    <input
                                      id="benzodiacepinatx_negativo"
                                      type="radio"
                                      {...field}
                                      name="benzodiacepinatx"
                                      value="Negativo"
                                      disabled={true}
                                      checked={
                                        selectedBenzodiacepina === "Negativo"
                                      }
                                      onChange={() => {
                                        field.onChange("Negativo");
                                        setSelectedBenzodiacepina("Negativo");
                                      }}
                                      className="print-radio"
                                    />
                                    {selectedBenzodiacepina === "Negativo" && (
                                      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-blue-600 rounded-full"></div>
                                    )}
                                  </div>
                                )}
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  {/* Columna PRUEBA EMPLEADA */}
                  <td
                    className="border-2 border-slate-700 text-left font-semibold p-2"
                    rowSpan={7}
                  >
                    <Label>No. LOTE:</Label>
                    <Controller
                      name="lotetx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="lotetx"
                          type="text"
                          {...field}
                          value={queryExamenTX.data?.lotetx}
                          disabled={true}
                        />
                      )}
                    />
                    <div className="mt-[25px]"></div>
                    <Label>FECHA CADUCIDAD:</Label>
                    <Controller
                      name="fecha_caducidadtx"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <TextInput
                          id="fecha_caducidadtx"
                          type="date"
                          {...field}
                          value={queryExamenTX.data?.fecha_caducidadtx}
                          disabled={true}
                        />
                      )}
                    />
                  </td>

                  {/* Columna DATOS DEL RECOLECTOR */}
                  <td
                    className="border-2 border-slate-700 font-semibold p-2"
                    rowSpan={7}
                  >
                    <div className="text-center">
                      {queryExamenTX.data?.nombre_recolectortx}
                      <Label className="text-center">
                        _______________________________
                      </Label>
                      <br />
                      <Label>Nombre</Label>
                    </div>
                    <br />
                    <div className="text-center">
                      <Label className="text-center">
                        _______________________________
                      </Label>
                      <br />
                      <Label>Firma</Label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
